module.exports = __webpack_public_path__ + "static/media/shell32_160.a4c7b3fb.ico";